export enum ConnectionType {
  Incoming = 0,
  Outgoing = 1,
  Active = 2
}

export enum CountryIso2 {
  GB = 'GB',
  AU = 'AU'
}
